export const buildNum = '12744';
export const buildEnvironment = 'production';
